import type { ChangeEvent, CSSProperties } from "react";

export type OtpSafeState = "idle" | "validating" | "success" | "error";

export function OtpSafeInput({
  value,
  onChange,
  state = "idle",
  disabled = false,
  length = 6,
  ariaLabel = "One-time verification code",
  id,
}: {
  value: string;
  onChange: (value: string) => void;
  state?: OtpSafeState;
  disabled?: boolean;
  length?: number;
  ariaLabel?: string;
  id?: string;
}) {
  const slots = ["one", "two", "three", "four", "five", "six", "seven", "eight", "nine", "ten"];
  const digits = slots.slice(0, length).map((slot, index) => ({ slot, value: value[index] ?? "" }));
  const update = (event: ChangeEvent<HTMLInputElement>) =>
    onChange(event.target.value.replace(/\D/g, "").slice(0, length));
  return (
    <span className={`otp-safe otp-safe-${state}`}>
      <input
        className="otp-safe-native"
        id={id}
        type="text"
        inputMode="numeric"
        autoComplete="one-time-code"
        value={value}
        onChange={update}
        disabled={disabled}
        aria-label={ariaLabel}
        aria-invalid={state === "error"}
        required
      />
      <span className="otp-safe-vault" aria-hidden="true">
        {digits.map((digit, index) => (
          <span
            className="otp-safe-digit"
            style={{ "--otp-index": index } as CSSProperties}
            key={digit.slot}
          >
            {digit.value || "•"}
          </span>
        ))}
      </span>
      <span className="otp-safe-status" aria-live="polite">
        {state === "validating"
          ? "Checking secure code"
          : state === "success"
            ? "Code accepted. Safe unlocked."
            : state === "error"
              ? "Code not accepted"
              : ""}
      </span>
    </span>
  );
}

export function otpUnlockDelay(): Promise<void> {
  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return Promise.resolve();
  return new Promise((resolve) => window.setTimeout(resolve, 700));
}
